const en = {
  permissionDeniedWeb: "Notifications are blocked in your browser settings.",
  webInstallRequired: "Add WIW to your Home Screen, then enable notifications there.",
  title: 'Notifications', empty: 'New activity will appear here', watch: 'Notify me about this author’s comments',
  unwatch: 'Turn off notifications about this author', newActivity: 'New activity',
  likes: '{{name}} liked your opinion', reposts: '{{name}} reposted your comment',
  subscriptions: '{{name}} followed you', author_comments: '{{name}} posted a new comment',
  authorCommentsSetting: 'New comments from authors', permissionDenied: 'Notifications were not enabled.',
  permissionDeniedIOS: 'Notifications are blocked in iPhone settings.',
  permissionDeniedAndroid: 'Notifications are blocked in Android settings.',
  deviceBrowser: "This browser does not support device notifications. Use the WIW app.",
  webUnavailable: "Browser notifications are temporarily unavailable. Try again later.",
  deviceUnavailable: 'Device notifications are not available here yet. Reopen the updated WIW app and try again.',
  devicePrompt: 'Permission has not been requested on this device.',
  deviceUnknown: 'Device permission has not been confirmed.',
  deviceRegistering: 'Connecting this device…', deviceUnregistered: 'This device is not connected for notifications.',
  openDeviceSettings: 'Open device settings', connectDevice: 'Connect this device',
  registrationFailed: 'Could not enable device notifications. Please try again.',
};
const ru = {
  permissionDeniedWeb: "Уведомления запрещены в настройках браузера.",
  webInstallRequired: "Добавьте WIW на экран «Домой», затем включите уведомления в нём.",
  title: 'Уведомления', empty: 'Здесь появятся новые события', watch: 'Уведомлять о комментариях автора',
  unwatch: 'Выключить уведомления об авторе', newActivity: 'Новые события',
  likes: '{{name}} оценил ваше мнение', reposts: '{{name}} поделился вашим комментарием',
  subscriptions: '{{name}} подписался на вас', author_comments: '{{name}} оставил новый комментарий',
  authorCommentsSetting: 'Новые комментарии авторов', permissionDenied: 'Уведомления не включены.',
  permissionDeniedIOS: 'Уведомления запрещены в настройках iPhone.',
  permissionDeniedAndroid: 'Уведомления запрещены в настройках Android.',
  deviceBrowser: "Этот браузер не поддерживает уведомления на устройстве. Откройте приложение WIW.",
  webUnavailable: "Уведомления в браузере временно недоступны. Попробуйте позже.",
  deviceUnavailable: 'Уведомления на этом устройстве пока недоступны. Откройте обновлённое приложение WIW и попробуйте ещё раз.',
  devicePrompt: 'Разрешение на этом устройстве ещё не запрашивалось.',
  deviceUnknown: 'Разрешение на уведомления на этом устройстве пока не подтверждено.',
  deviceRegistering: 'Подключаем устройство…', deviceUnregistered: 'Устройство не подключено к уведомлениям.',
  openDeviceSettings: 'Открыть настройки устройства', connectDevice: 'Подключить устройство',
  registrationFailed: 'Не удалось включить уведомления на устройстве. Попробуйте ещё раз.',
};
const es = {
  permissionDeniedWeb: "Las notificaciones están bloqueadas en los ajustes del navegador.",
  webInstallRequired: "Añade WIW a la pantalla de inicio y activa las notificaciones desde allí.",
  title: 'Notificaciones', empty: 'Aquí aparecerá la actividad nueva', watch: 'Avisarme de los comentarios de este autor',
  unwatch: 'Desactivar las notificaciones de este autor', newActivity: 'Nueva actividad',
  likes: 'A {{name}} le gustó tu opinión', reposts: '{{name}} compartió tu comentario',
  subscriptions: '{{name}} empezó a seguirte', author_comments: '{{name}} publicó un nuevo comentario',
  authorCommentsSetting: 'Nuevos comentarios de autores', permissionDenied: 'No se activaron las notificaciones.',
  permissionDeniedIOS: 'Las notificaciones están bloqueadas en los ajustes del iPhone.',
  permissionDeniedAndroid: 'Las notificaciones están bloqueadas en los ajustes de Android.',
  deviceBrowser: "Este navegador no admite notificaciones en el dispositivo. Usa la aplicación WIW.",
  webUnavailable: "Las notificaciones del navegador no están disponibles temporalmente. Inténtalo más tarde.",
  deviceUnavailable: 'Las notificaciones aún no están disponibles en este dispositivo. Vuelve a abrir la aplicación WIW actualizada e inténtalo de nuevo.',
  devicePrompt: 'Aún no se ha solicitado permiso en este dispositivo.',
  deviceUnknown: 'Aún no se ha confirmado el permiso en este dispositivo.',
  deviceRegistering: 'Conectando este dispositivo…', deviceUnregistered: 'Este dispositivo no está conectado para recibir notificaciones.',
  openDeviceSettings: 'Abrir los ajustes del dispositivo', connectDevice: 'Conectar este dispositivo',
  registrationFailed: 'No se pudieron activar las notificaciones del dispositivo. Inténtalo de nuevo.',
};
const fr = {
  permissionDeniedWeb: "Les notifications sont bloquées dans les paramètres du navigateur.",
  webInstallRequired: "Ajoutez WIW à l’écran d’accueil, puis activez les notifications depuis cette application.",
  title: 'Notifications', empty: 'Les nouvelles activités apparaîtront ici', watch: 'M’avertir des commentaires de cet auteur',
  unwatch: 'Désactiver les notifications de cet auteur', newActivity: 'Nouvelle activité',
  likes: '{{name}} a aimé votre avis', reposts: '{{name}} a partagé votre commentaire',
  subscriptions: '{{name}} vous suit désormais', author_comments: '{{name}} a publié un nouveau commentaire',
  authorCommentsSetting: 'Nouveaux commentaires des auteurs', permissionDenied: 'Les notifications n’ont pas été activées.',
  permissionDeniedIOS: 'Les notifications sont bloquées dans les réglages de l’iPhone.',
  permissionDeniedAndroid: 'Les notifications sont bloquées dans les paramètres Android.',
  deviceBrowser: "Ce navigateur ne prend pas en charge les notifications sur cet appareil. Utilisez l’application WIW.",
  webUnavailable: "Les notifications du navigateur sont temporairement indisponibles. Réessayez plus tard.",
  deviceUnavailable: 'Les notifications ne sont pas encore disponibles sur cet appareil. Rouvrez l’application WIW mise à jour et réessayez.',
  devicePrompt: 'L’autorisation n’a pas encore été demandée sur cet appareil.',
  deviceUnknown: 'L’autorisation sur cet appareil n’a pas encore été confirmée.',
  deviceRegistering: 'Connexion de cet appareil…', deviceUnregistered: 'Cet appareil n’est pas connecté pour recevoir des notifications.',
  openDeviceSettings: 'Ouvrir les paramètres de l’appareil', connectDevice: 'Connecter cet appareil',
  registrationFailed: 'Impossible d’activer les notifications sur cet appareil. Réessayez.',
};
const ja = {
  permissionDeniedWeb: "ブラウザの設定で通知がブロックされています。",
  webInstallRequired: "WIWをホーム画面に追加し、そこから開いて通知を有効にしてください。",
  title: '通知', empty: '新しいアクティビティがここに表示されます', watch: 'この投稿者のコメントを通知する',
  unwatch: 'この投稿者の通知をオフにする', newActivity: '新しいアクティビティ',
  likes: '{{name}}さんがあなたの意見にいいねしました', reposts: '{{name}}さんがあなたのコメントを再投稿しました',
  subscriptions: '{{name}}さんがあなたをフォローしました', author_comments: '{{name}}さんが新しいコメントを投稿しました',
  authorCommentsSetting: '投稿者の新しいコメント', permissionDenied: '通知は有効になっていません。',
  permissionDeniedIOS: 'iPhoneの設定で通知がブロックされています。',
  permissionDeniedAndroid: 'Androidの設定で通知がブロックされています。',
  deviceBrowser: "このブラウザは端末への通知に対応していません。WIWアプリをご利用ください。",
  webUnavailable: "ブラウザ通知は一時的に利用できません。しばらくしてからもう一度お試しください。",
  deviceUnavailable: 'この端末ではまだ通知を利用できません。最新版のWIWアプリを開き直して、もう一度お試しください。',
  devicePrompt: 'この端末ではまだ通知の許可を求めていません。',
  deviceUnknown: 'この端末の通知の許可が確認できていません。',
  deviceRegistering: 'この端末を接続しています…', deviceUnregistered: 'この端末は通知を受信するための接続が完了していません。',
  openDeviceSettings: '端末の設定を開く', connectDevice: 'この端末を接続',
  registrationFailed: '端末への通知を有効にできませんでした。もう一度お試しください。',
};
const ko = {
  permissionDeniedWeb: "브라우저 설정에서 알림이 차단되어 있습니다.",
  webInstallRequired: "WIW를 홈 화면에 추가한 뒤 그곳에서 열어 알림을 켜세요.",
  title: '알림', empty: '새로운 활동이 여기에 표시됩니다', watch: '이 작성자의 댓글 알림 받기',
  unwatch: '이 작성자의 알림 끄기', newActivity: '새로운 활동',
  likes: '{{name}}님이 내 의견을 좋아합니다', reposts: '{{name}}님이 내 댓글을 재게시했습니다',
  subscriptions: '{{name}}님이 나를 팔로우했습니다', author_comments: '{{name}}님이 새 댓글을 남겼습니다',
  authorCommentsSetting: '작성자의 새 댓글', permissionDenied: '알림이 활성화되지 않았습니다.',
  permissionDeniedIOS: 'iPhone 설정에서 알림이 차단되어 있습니다.',
  permissionDeniedAndroid: 'Android 설정에서 알림이 차단되어 있습니다.',
  deviceBrowser: "이 브라우저는 기기 알림을 지원하지 않습니다. WIW 앱을 이용해 주세요.",
  webUnavailable: "브라우저 알림을 일시적으로 사용할 수 없습니다. 나중에 다시 시도해 주세요.",
  deviceUnavailable: '이 기기에서는 아직 알림을 사용할 수 없습니다. 업데이트된 WIW 앱을 다시 열고 시도해 주세요.',
  devicePrompt: '이 기기에서 아직 알림 권한을 요청하지 않았습니다.',
  deviceUnknown: '이 기기의 알림 권한이 아직 확인되지 않았습니다.',
  deviceRegistering: '이 기기를 연결하는 중…', deviceUnregistered: '이 기기는 알림을 받도록 연결되어 있지 않습니다.',
  openDeviceSettings: '기기 설정 열기', connectDevice: '이 기기 연결',
  registrationFailed: '기기 알림을 활성화하지 못했습니다. 다시 시도해 주세요.',
};
const pt = {
  permissionDeniedWeb: "As notificações estão bloqueadas nas configurações do navegador.",
  webInstallRequired: "Adicione o WIW à tela inicial e ative as notificações por lá.",
  title: 'Notificações', empty: 'Novas atividades aparecerão aqui', watch: 'Receber notificações dos comentários deste autor',
  unwatch: 'Desativar notificações deste autor', newActivity: 'Nova atividade',
  likes: '{{name}} curtiu sua opinião', reposts: '{{name}} compartilhou seu comentário',
  subscriptions: '{{name}} começou a seguir você', author_comments: '{{name}} publicou um novo comentário',
  authorCommentsSetting: 'Novos comentários de autores', permissionDenied: 'As notificações não foram ativadas.',
  permissionDeniedIOS: 'As notificações estão bloqueadas nos ajustes do iPhone.',
  permissionDeniedAndroid: 'As notificações estão bloqueadas nas configurações do Android.',
  deviceBrowser: "Este navegador não oferece suporte a notificações no dispositivo. Use o aplicativo WIW.",
  webUnavailable: "As notificações do navegador estão temporariamente indisponíveis. Tente novamente mais tarde.",
  deviceUnavailable: 'As notificações ainda não estão disponíveis neste dispositivo. Abra novamente o aplicativo WIW atualizado e tente de novo.',
  devicePrompt: 'A permissão ainda não foi solicitada neste dispositivo.',
  deviceUnknown: 'A permissão neste dispositivo ainda não foi confirmada.',
  deviceRegistering: 'Conectando este dispositivo…', deviceUnregistered: 'Este dispositivo não está conectado para receber notificações.',
  openDeviceSettings: 'Abrir configurações do dispositivo', connectDevice: 'Conectar este dispositivo',
  registrationFailed: 'Não foi possível ativar as notificações no dispositivo. Tente novamente.',
};
const tr = {
  permissionDeniedWeb: "Bildirimler tarayıcı ayarlarında engellenmiş.",
  webInstallRequired: "WIW’yi ana ekrana ekleyin, ardından oradan açıp bildirimleri etkinleştirin.",
  title: 'Bildirimler', empty: 'Yeni etkinlikler burada görünecek', watch: 'Bu yazarın yorumlarını bildir',
  unwatch: 'Bu yazarın bildirimlerini kapat', newActivity: 'Yeni etkinlik',
  likes: '{{name}} görüşünüzü beğendi', reposts: '{{name}} yorumunuzu yeniden paylaştı',
  subscriptions: '{{name}} sizi takip etmeye başladı', author_comments: '{{name}} yeni bir yorum paylaştı',
  authorCommentsSetting: 'Yazarların yeni yorumları', permissionDenied: 'Bildirimler etkinleştirilmedi.',
  permissionDeniedIOS: 'Bildirimler iPhone ayarlarında engellenmiş.',
  permissionDeniedAndroid: 'Bildirimler Android ayarlarında engellenmiş.',
  deviceBrowser: "Bu tarayıcı cihaz bildirimlerini desteklemiyor. WIW uygulamasını kullanın.",
  webUnavailable: "Tarayıcı bildirimleri geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
  deviceUnavailable: 'Bu cihazda bildirimler henüz kullanılamıyor. Güncellenmiş WIW uygulamasını yeniden açıp tekrar deneyin.',
  devicePrompt: 'Bu cihazda henüz bildirim izni istenmedi.',
  deviceUnknown: 'Bu cihazdaki bildirim izni henüz doğrulanmadı.',
  deviceRegistering: 'Bu cihaz bağlanıyor…', deviceUnregistered: 'Bu cihaz bildirim almak için bağlı değil.',
  openDeviceSettings: 'Cihaz ayarlarını aç', connectDevice: 'Bu cihazı bağla',
  registrationFailed: 'Cihaz bildirimleri etkinleştirilemedi. Lütfen tekrar deneyin.',
};
const zh = {
  permissionDeniedWeb: "通知已在浏览器设置中被禁用。",
  webInstallRequired: "请将WIW添加到主屏幕，然后从那里打开并启用通知。",
  title: '通知', empty: '新动态会显示在这里', watch: '接收这位作者的评论通知',
  unwatch: '关闭这位作者的通知', newActivity: '新动态',
  likes: '{{name}}赞了你的观点', reposts: '{{name}}转发了你的评论',
  subscriptions: '{{name}}关注了你', author_comments: '{{name}}发表了新评论',
  authorCommentsSetting: '作者的新评论', permissionDenied: '通知尚未开启。',
  permissionDeniedIOS: '通知已在iPhone设置中被禁用。',
  permissionDeniedAndroid: '通知已在Android设置中被禁用。',
  deviceBrowser: "此浏览器不支持设备通知。请使用WIW应用。",
  webUnavailable: "浏览器通知暂时不可用，请稍后重试。",
  deviceUnavailable: '此设备暂时无法接收通知。请重新打开更新后的WIW应用，然后重试。',
  devicePrompt: '尚未在此设备上请求通知权限。',
  deviceUnknown: '尚未确认此设备的通知权限。',
  deviceRegistering: '正在连接此设备…', deviceUnregistered: '此设备尚未连接，无法接收通知。',
  openDeviceSettings: '打开设备设置', connectDevice: '连接此设备',
  registrationFailed: '无法开启设备通知，请重试。',
};
const de = {
  permissionDeniedWeb: "Benachrichtigungen sind in den Browsereinstellungen blockiert.",
  webInstallRequired: "Füge WIW zum Home-Bildschirm hinzu und aktiviere dort die Benachrichtigungen.",
  title: 'Benachrichtigungen', empty: 'Neue Aktivitäten werden hier angezeigt', watch: 'Über Kommentare dieser Person benachrichtigen',
  unwatch: 'Benachrichtigungen zu dieser Person ausschalten', newActivity: 'Neue Aktivität',
  likes: '{{name}} gefällt deine Meinung', reposts: '{{name}} hat deinen Kommentar geteilt',
  subscriptions: '{{name}} folgt dir jetzt', author_comments: '{{name}} hat einen neuen Kommentar veröffentlicht',
  authorCommentsSetting: 'Neue Kommentare von Autoren', permissionDenied: 'Benachrichtigungen wurden nicht aktiviert.',
  permissionDeniedIOS: 'Benachrichtigungen sind in den iPhone-Einstellungen blockiert.',
  permissionDeniedAndroid: 'Benachrichtigungen sind in den Android-Einstellungen blockiert.',
  deviceBrowser: "Dieser Browser unterstützt keine Gerätebenachrichtigungen. Nutze die WIW-App.",
  webUnavailable: "Browserbenachrichtigungen sind vorübergehend nicht verfügbar. Versuche es später erneut.",
  deviceUnavailable: 'Benachrichtigungen sind auf diesem Gerät noch nicht verfügbar. Öffne die aktualisierte WIW-App erneut und versuche es noch einmal.',
  devicePrompt: 'Auf diesem Gerät wurde noch keine Berechtigung angefragt.',
  deviceUnknown: 'Die Berechtigung auf diesem Gerät wurde noch nicht bestätigt.',
  deviceRegistering: 'Dieses Gerät wird verbunden…', deviceUnregistered: 'Dieses Gerät ist nicht für den Empfang von Benachrichtigungen verbunden.',
  openDeviceSettings: 'Geräteeinstellungen öffnen', connectDevice: 'Dieses Gerät verbinden',
  registrationFailed: 'Benachrichtigungen konnten auf diesem Gerät nicht aktiviert werden. Versuche es erneut.',
};
const it = {
  permissionDeniedWeb: "Le notifiche sono bloccate nelle impostazioni del browser.",
  webInstallRequired: "Aggiungi WIW alla schermata Home, poi aprilo da lì e attiva le notifiche.",
  title: 'Notifiche', empty: 'Le nuove attività appariranno qui', watch: 'Avvisami dei commenti di questo autore',
  unwatch: 'Disattiva le notifiche di questo autore', newActivity: 'Nuova attività',
  likes: 'A {{name}} piace la tua opinione', reposts: '{{name}} ha ricondiviso il tuo commento',
  subscriptions: '{{name}} ha iniziato a seguirti', author_comments: '{{name}} ha pubblicato un nuovo commento',
  authorCommentsSetting: 'Nuovi commenti degli autori', permissionDenied: 'Le notifiche non sono state attivate.',
  permissionDeniedIOS: 'Le notifiche sono bloccate nelle impostazioni dell’iPhone.',
  permissionDeniedAndroid: 'Le notifiche sono bloccate nelle impostazioni di Android.',
  deviceBrowser: "Questo browser non supporta le notifiche sul dispositivo. Usa l’app WIW.",
  webUnavailable: "Le notifiche del browser sono temporaneamente non disponibili. Riprova più tardi.",
  deviceUnavailable: 'Le notifiche non sono ancora disponibili su questo dispositivo. Riapri l’app WIW aggiornata e riprova.',
  devicePrompt: 'L’autorizzazione non è ancora stata richiesta su questo dispositivo.',
  deviceUnknown: 'L’autorizzazione su questo dispositivo non è ancora stata confermata.',
  deviceRegistering: 'Connessione del dispositivo…', deviceUnregistered: 'Questo dispositivo non è connesso per ricevere notifiche.',
  openDeviceSettings: 'Apri le impostazioni del dispositivo', connectDevice: 'Connetti questo dispositivo',
  registrationFailed: 'Impossibile attivare le notifiche sul dispositivo. Riprova.',
};
const hi = {
  permissionDeniedWeb: "ब्राउज़र की सेटिंग में सूचनाएँ बंद हैं।",
  webInstallRequired: "WIW को होम स्क्रीन पर जोड़ें, फिर वहाँ से खोलकर सूचनाएँ चालू करें।",
  title: 'सूचनाएँ', empty: 'नई गतिविधियाँ यहाँ दिखाई देंगी', watch: 'इस लेखक की टिप्पणियों की सूचना पाएँ',
  unwatch: 'इस लेखक की सूचनाएँ बंद करें', newActivity: 'नई गतिविधि',
  likes: '{{name}} ने आपकी राय पसंद की', reposts: '{{name}} ने आपकी टिप्पणी रीपोस्ट की',
  subscriptions: '{{name}} ने आपको फ़ॉलो करना शुरू किया', author_comments: '{{name}} ने नई टिप्पणी की',
  authorCommentsSetting: 'लेखकों की नई टिप्पणियाँ', permissionDenied: 'सूचनाएँ चालू नहीं हुईं।',
  permissionDeniedIOS: 'iPhone की सेटिंग में सूचनाएँ बंद हैं।',
  permissionDeniedAndroid: 'Android की सेटिंग में सूचनाएँ बंद हैं।',
  deviceBrowser: "यह ब्राउज़र डिवाइस पर सूचनाएँ भेजने की सुविधा नहीं देता। WIW ऐप का इस्तेमाल करें।",
  webUnavailable: "ब्राउज़र सूचनाएँ फ़िलहाल उपलब्ध नहीं हैं। कृपया बाद में फिर कोशिश करें।",
  deviceUnavailable: 'इस डिवाइस पर सूचनाएँ अभी उपलब्ध नहीं हैं। अपडेट किया हुआ WIW ऐप फिर से खोलें और दोबारा कोशिश करें।',
  devicePrompt: 'इस डिवाइस पर अभी सूचनाओं की अनुमति नहीं माँगी गई है।',
  deviceUnknown: 'इस डिवाइस पर सूचनाओं की अनुमति की पुष्टि अभी नहीं हुई है।',
  deviceRegistering: 'इस डिवाइस को कनेक्ट किया जा रहा है…', deviceUnregistered: 'यह डिवाइस सूचनाएँ पाने के लिए कनेक्ट नहीं है।',
  openDeviceSettings: 'डिवाइस की सेटिंग खोलें', connectDevice: 'इस डिवाइस को कनेक्ट करें',
  registrationFailed: 'डिवाइस पर सूचनाएँ चालू नहीं हो सकीं। फिर कोशिश करें।',
};
const translations = { en, ru, es, fr, ja, ko, pt, tr, zh, de, it, hi };
export default translations;
